function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { fileToBase64 } from '@isyc-react/archives';
import { NotificationItemType } from '@isyc-react/form/modules/base/notification-hub';
import { useNotificationHubContext } from '@isyc-react/form/modules/context/notification-hub';
import { awaitableApollo } from '@isyc-react/oc-api/apollo';
import { useArchiveCreateFrontAndBackListInternalMutationPromise, useArchiveCreateListInternalMutationPromise, useDocumentalValidationRelatedReadQueryPromise } from '@isyc-react/oc-api/queries';
import { ArchiveReceptionChannel, DocumentTypeFormat, DocumentalIgnoredCode, DocumentalTypologyResult, DocumentalValidationCode, ObjectTypeId } from '@isyc-react/types';
import { nanoid } from 'nanoid';
import React from 'react';
import { DocValidationFileMaxSize, DocumentalValidationErrorCode } from "./deprecated-documental-validation";
import { Spinner } from '@isyc-react/design/bootstrap';
import { nsnewo } from "../../../i18n/namespaces";
import { ArchiveInputState } from "../../types/deprecated-documental-validation";
import { useTranslation } from 'react-i18next';
import { NewoDropMultiFileNoTypology } from "../dropMultiFile";
import { DeprecatedDocumentalDropFile } from "./deprecated-documental-drop-file";
import { useArchiveReadQueryByRelatedAndTypologyWithOnlyDocumentPromise } from "../../common/api/graphql";

//

//DOCUMENTAL VALIDATION

export const DeprecatedDocumentalValidation = props => {
  const {
    dossierId,
    dossierBusinessUnitId,
    FileMaxSizeBytes,
    dropMultifileProps,
    documentalInvididualValidationEnable
  } = props;
  const {
    t
  } = useTranslation(nsnewo.common);
  const {
    addNotifications
  } = useNotificationHubContext();
  const relatedDocumentalValidation = useDocumentalValidationRelatedReadQueryPromise();
  const archiveRelatedByTypologyWithOnlyDocument = useArchiveReadQueryByRelatedAndTypologyWithOnlyDocumentPromise();
  const archiveCreateList = useArchiveCreateListInternalMutationPromise();
  const archiveCreateFrontBackList = useArchiveCreateFrontAndBackListInternalMutationPromise();
  const [fetchingDocumentalData, setFetchingDocumentalData] = React.useState();
  const [fetchingNonTypologyData, setFetchingNonTypologyData] = React.useState();
  const [errorDocumentalData, setErrorDocumentalData] = React.useState();
  const [errorNonTypologyData, setErrorNonTypologyData] = React.useState();

  //State of the documental
  const [documentalDataList, setDocumentalDataList] = React.useState([]);
  const [nonTypologyData, setNonTypologyData] = React.useState({
    dropMultiFileValue: {
      accepted: [],
      rejected: []
    },
    arhiveIdStateRecord: {},
    archiveIdDocumentalResultRecord: {}
  });
  const updateDocumentalDataEntry = documentalData => {
    setDocumentalDataList(state => state.map(x => {
      if (x.id === documentalData.id) {
        return documentalData;
      }
      return x;
    }));
  };
  React.useEffect(() => {
    //Upload documents that are pending
    documentalDataList.forEach(x => {
      if (x.archiveInputState === ArchiveInputState.Pending) {
        uploadDocumental(x);
      }
    });
  }, [documentalDataList]);
  React.useEffect(() => {
    for (const value of nonTypologyData.dropMultiFileValue.accepted) {
      if (nonTypologyData.arhiveIdStateRecord[value.id] === ArchiveInputState.Pending) {
        uploadNonTypologySingle(value);
      }
    }
  }, [nonTypologyData]);

  //Shows an error notification and updates the documental
  const onUploadError = (documentalData, message) => {
    addNotifications([{
      key: nanoid(),
      message,
      persist: false,
      life: 5000,
      type: NotificationItemType.ERROR
    }]);
    const errors = documentalError(documentalData, [], [DocumentalValidationErrorCode.DOCUMENT_EDM_ERROR]);
    updateDocumentalDataEntry(_objectSpread(_objectSpread({}, documentalData), {}, {
      errors,
      archiveInputState: ArchiveInputState.Failed
    }));
  };

  //UPLOAD METHODS
  //Upload an archive
  const uploadSingle = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (documentalData) {
      var _archive$data;
      if (!documentalData.file || !documentalData.documentTypeId) {
        return;
      }
      updateDocumentalDataEntry(_objectSpread(_objectSpread({}, documentalData), {}, {
        archiveInputState: ArchiveInputState.Uploading
      }));

      // File to base64
      const base64 = yield fileToBase64(documentalData.file);
      const relatedId = documentalData.consideredId || documentalData.relatedId;
      const relatedObjectTypeId = documentalData.consideredObjectTypeId || documentalData.relatedObjectTypeId;

      // Create Archive
      const archive = yield awaitableApollo(archiveCreateList({
        archiveCreateListInternal: [{
          name: documentalData.file.name,
          content: base64,
          receptionChannelType: ArchiveReceptionChannel.WEB_PORTAL,
          typologyTemplateIdList: [documentalData.documentTypeId],
          relatedId,
          relatedObjectTypeId
        }],
        businessUnitId: dossierBusinessUnitId
      }));
      if (archive.error || archive.errors || !((_archive$data = archive.data) !== null && _archive$data !== void 0 && _archive$data.archive_createListInternal)) {
        onUploadError(documentalData, t('newo.documentalValidation.uploadError', {
          fileName: documentalData.file.name
        }));
        return;
      }
      updateDocumentalDataEntry(_objectSpread(_objectSpread({}, documentalData), {}, {
        archiveInputState: ArchiveInputState.Uploaded
      }));
      addNotifications([{
        key: nanoid(),
        message: t('newo.documentalValidation.uploadSuccess', {
          fileName: documentalData.file.name
        }),
        persist: false,
        life: 5000,
        type: NotificationItemType.SUCCESS
      }]);
    });
    return function uploadSingle(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  //Uploads an archive with front/back faces (ie: DNI)
  const uploadFrontBack = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (documentalData) {
      var _archive$data2;
      if (!documentalData.front || !documentalData.back || !documentalData.documentTypeId || !documentalData.documentTypeCode) {
        return;
      }
      const [frontBase64, backBase64] = yield Promise.all([fileToBase64(documentalData.front), fileToBase64(documentalData.back)]);
      const relatedId = documentalData.consideredId || documentalData.relatedId;
      const relatedObjectTypeId = documentalData.consideredObjectTypeId || documentalData.relatedObjectTypeId;

      //Create archive
      const archive = yield awaitableApollo(archiveCreateFrontBackList({
        archiveCreateFrontAndBackListInternal: [{
          nameFront: documentalData.front.name,
          contentFront: frontBase64,
          nameBack: documentalData.back.name,
          contentBack: backBase64,
          receptionChannelType: ArchiveReceptionChannel.WEB_PORTAL,
          typologyTemplateIdList: [documentalData.documentTypeId],
          relatedObjectTypeId,
          relatedId
        }],
        businessUnitId: dossierBusinessUnitId
      }));
      if (archive.error || archive.errors || !((_archive$data2 = archive.data) !== null && _archive$data2 !== void 0 && _archive$data2.archive_createFrontAndBackListInternal)) {
        onUploadError(documentalData, t('newo.documentalValidation.createFrontBackError', {
          frontFileName: documentalData.front.name,
          backFileName: documentalData.back.name,
          dossierId: dossierId
        }));
        return;
      }
      updateDocumentalDataEntry(_objectSpread(_objectSpread({}, documentalData), {}, {
        archiveInputState: ArchiveInputState.Uploaded
      }));
    });
    return function uploadFrontBack(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  //Uploads an archive depending on it's type
  const uploadDocumental = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(function* (documentalData) {
      if (documentalData.documentTypeFormat === DocumentTypeFormat.FRONT_BACK) {
        yield uploadFrontBack(documentalData);
      } else {
        yield uploadSingle(documentalData);
      }
    });
    return function uploadDocumental(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  //Upload an archive without typology
  const uploadNonTypologySingle = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(function* (value) {
      var _archive$data3, _archive$data4;
      if (!value.file || !dropMultifileProps) {
        return;
      }
      setNonTypologyData(state => _objectSpread(_objectSpread({}, state), {}, {
        arhiveIdStateRecord: _objectSpread(_objectSpread({}, state.arhiveIdStateRecord), {}, {
          [value.id]: ArchiveInputState.Uploading
        })
      }));

      // File to base64
      const base64 = yield fileToBase64(value.file);

      //Create archive
      const archive = yield awaitableApollo(archiveCreateList({
        archiveCreateListInternal: [{
          name: value.file.name,
          content: base64,
          relatedId: dossierId,
          relatedObjectTypeId: ObjectTypeId.DOSSIER,
          receptionChannelType: ArchiveReceptionChannel.WEB_PORTAL,
          typologies: [{
            code: dropMultifileProps.othersTypologyCode
          }]
        }],
        businessUnitId: dossierBusinessUnitId
      }));
      if (archive.error || archive.errors || !((_archive$data3 = archive.data) !== null && _archive$data3 !== void 0 && _archive$data3.archive_createListInternal)) {
        addNotifications([{
          key: nanoid(),
          message: t('newo.documentalValidation.uploadError', {
            fileName: value.file.name
          }),
          persist: false,
          life: 5000,
          type: NotificationItemType.ERROR
        }]);
        return;
      }
      const typologyResult = (_archive$data4 = archive.data) === null || _archive$data4 === void 0 ? void 0 : _archive$data4.archive_createListInternal[0].documents[0].state;
      setNonTypologyData(state => _objectSpread(_objectSpread({}, state), {}, {
        arhiveIdStateRecord: _objectSpread(_objectSpread({}, state.arhiveIdStateRecord), {}, {
          [value.id]: ArchiveInputState.Uploaded
        }),
        archiveIdDocumentalResultRecord: _objectSpread(_objectSpread({}, state.archiveIdDocumentalResultRecord), {}, {
          [value.id]: typologyResult
        })
      }));
      addNotifications([{
        key: nanoid(),
        message: t('newo.documentalValidation.uploadSuccess', {
          fileName: value.file.name
        }),
        persist: false,
        life: 5000,
        type: NotificationItemType.SUCCESS
      }]);
    });
    return function uploadNonTypologySingle(_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
  //END UPLOAD METHODS

  //DROP FILE METHODS
  const onAccepted = (target, documentalData, file) => {
    const errors = documentalError(documentalData, [DocumentalValidationErrorCode.NO_ACCEPTED_FILE, DocumentalValidationErrorCode.REJECTED_FILE, DocumentalValidationErrorCode.LOW_FILE_QUALITY, DocumentalValidationErrorCode.DOCUMENT_EDM_ERROR], []);
    if (documentalData.documentTypeFormat !== DocumentTypeFormat.FRONT_BACK) {
      updateDocumentalDataEntry(_objectSpread(_objectSpread({}, documentalData), {}, {
        [target]: file,
        errors,
        archiveInputState: ArchiveInputState.Pending
      }));
    } else {
      //TODO: If it's front/back, we need both to put it as a pending.
      console.error('TODO: onAccepted, frontBack');
    }
  };
  const onRemoveAccepted = (target, documentalData) => {
    const errors = documentalError(documentalData, [DocumentalValidationErrorCode.LOW_FILE_QUALITY, DocumentalValidationErrorCode.DOCUMENT_EDM_ERROR], []);
    updateDocumentalDataEntry(_objectSpread(_objectSpread({}, documentalData), {}, {
      errors,
      [target]: undefined,
      archiveInputState: ArchiveInputState.None
    }));
  };
  const onRejected = (target, documentalData) => {
    const errors = documentalError(documentalData, [DocumentalValidationErrorCode.LOW_FILE_QUALITY, DocumentalValidationErrorCode.DOCUMENT_EDM_ERROR], [DocumentalValidationErrorCode.REJECTED_FILE]);
    updateDocumentalDataEntry(_objectSpread(_objectSpread({}, documentalData), {}, {
      errors,
      [target]: undefined,
      archiveInputState: ArchiveInputState.None
    }));
  };
  const onRemoveRejected = documentalData => {
    const errors = documentalError(documentalData, [DocumentalValidationErrorCode.REJECTED_FILE], []);
    updateDocumentalDataEntry(_objectSpread(_objectSpread({}, documentalData), {}, {
      errors,
      archiveInputState: ArchiveInputState.None
    }));
  };

  //END DROP FILE METHODS

  //MULTIDROP FILE METHODS

  const onChangeMultiDrop = value => {
    const archiveIdStateRecord = nonTypologyData.arhiveIdStateRecord;
    for (const fileIdValue of value.accepted) {
      if (archiveIdStateRecord[fileIdValue.id] === undefined) {
        archiveIdStateRecord[fileIdValue.id] = ArchiveInputState.Pending;
      }
    }
    setNonTypologyData(state => _objectSpread(_objectSpread({}, state), {}, {
      dropMultiFileValue: value,
      arhiveIdStateRecord: archiveIdStateRecord
    }));
  };

  //END MULTIDROP FILE METHODS

  const onOptionSelected = (option, documentalData) => {
    if (!option) return;
    const errors = documentalError(documentalData, [DocumentalValidationErrorCode.NO_OPTION_SELECTED, DocumentalValidationErrorCode.NO_ACCEPTED_FILE, DocumentalValidationErrorCode.REJECTED_FILE], []);
    updateDocumentalDataEntry(_objectSpread(_objectSpread({}, documentalData), {}, {
      errors,
      documentTypeId: option.documentTypeId,
      documentTypeCode: option.documentTypeCode,
      documentTypeFormat: option.documentTypeFormat,
      back: undefined,
      front: undefined
    }));
  };
  React.useEffect(() => {
    setFetchingDocumentalData(state => true);
    relatedDocumentalValidation({
      relatedObjectTypeId: ObjectTypeId.DOSSIER,
      relatedId: dossierId
    }).then(documentalValidationData => {
      if (documentalValidationData.errors || !documentalValidationData.data.documentalValidation_read_byRelated) {
        //TODO: Set fetching false, set error => error: DocumentalValidationErrorCode.GET_GENERIC
        setFetchingDocumentalData(state => false);
        setErrorDocumentalData(state => true);
        return;
      }
      const documentalValidation = documentalValidationData.data.documentalValidation_read_byRelated;
      const documentalData = [];

      //Populate documentalData from documentalValidation
      documentalValidation.forEach(docValidation => {
        const typologyAndDocumentsKeys = Object.keys(docValidation.evaluationResults.typologyAndDocuments);
        if (docValidation.validation === DocumentalValidationCode.ANY) {
          const options = docValidation.documentalValidationLines.filter(line => line.ignored === DocumentalIgnoredCode.NOT_IGNORED).map(line => ({
            value: line.documentTypeId.toString(),
            label: line.documentTypeName,
            documentTypeCode: line.documentTypeCode,
            documentTypeId: line.documentTypeId,
            documentTypeFormat: line.documentTypeFormatList.length === 1 ? line.documentTypeFormatList[0] : DocumentTypeFormat.SINGLE
          })).sort((optionA, optionB) => parseInt(optionA.value) - parseInt(optionB.value));

          //Create DocumentalData
          let documentalTypologyResult = DocumentalTypologyResult.TYPOLOGY_RESULT_NO_INFO;
          let documentTypeId = undefined;
          let documentTypeFormat = undefined;
          let documentTypeCode = undefined;
          let initialSelectedOption = undefined;
          let uploadedArchiveId = undefined;
          let uploadedArchiveName = undefined;
          let required = true;
          let archiveInputState = ArchiveInputState.None;

          //TODO: typologyAndDocumentsKeys coger el de creationTimestamp mayor que lo cumpla, no el 0 (y mirar tema status si afecta)
          if (typologyAndDocumentsKeys.length) {
            const selectedOption = options.find(option => option.value === typologyAndDocumentsKeys[0]);
            if (selectedOption) {
              initialSelectedOption = selectedOption;
              documentTypeId = selectedOption.documentTypeId;
              documentTypeFormat = selectedOption.documentTypeFormat;
              documentTypeCode = selectedOption.documentTypeCode;
              uploadedArchiveId = docValidation.evaluationResults.typologyAndDocuments[selectedOption.value][0].archiveId;
              uploadedArchiveName = docValidation.evaluationResults.typologyAndDocuments[selectedOption.value][0].archiveName;
              archiveInputState = ArchiveInputState.Uploaded;
              documentalTypologyResult = docValidation.evaluationResults.typologyResultMap[selectedOption.value];
            }
          }
          documentalData.push({
            id: docValidation.id,
            title: docValidation.documentalGroupName,
            archiveInputState: archiveInputState,
            required,
            errors: [],
            uploadedArchiveId,
            uploadedArchiveName,
            options,
            documentalTypologyResult,
            initialSelectedOption,
            documentTypeId,
            documentTypeFormat,
            documentTypeCode,
            relatedId: docValidation.relatedId,
            relatedObjectTypeId: docValidation.relatedObjectTypeId,
            consideredId: docValidation.consideredId,
            consideredObjectTypeId: docValidation.consideredObjectTypeId
          });
        } else {
          docValidation.documentalValidationLines.forEach(validationLine => {
            if (validationLine.ignored === DocumentalIgnoredCode.NOT_IGNORED) {
              const uploadedKey = typologyAndDocumentsKeys.find(key => key === validationLine.documentTypeId.toString());
              const documentalTypologyResult = docValidation.evaluationResults.typologyResultMap[validationLine.documentTypeId];
              let uploadedArchiveId = undefined;
              let uploadedArchiveName = undefined;
              let archiveInputState = ArchiveInputState.None;
              if (uploadedKey) {
                archiveInputState = ArchiveInputState.Uploaded;
                uploadedArchiveId = docValidation.evaluationResults.typologyAndDocuments[uploadedKey][0].archiveId;
                uploadedArchiveName = docValidation.evaluationResults.typologyAndDocuments[uploadedKey][0].archiveName;
                //TODO: typologyAndDocumentsKeys coger el de creationTimestamp mayor que lo cumpla, no el 0 (y mirar tema status si afecta)
              }
              documentalData.push({
                id: validationLine.id,
                title: validationLine.documentTypeName,
                archiveInputState: archiveInputState,
                required: docValidation.validation === DocumentalValidationCode.ALL,
                errors: [],
                documentalTypologyResult,
                uploadedArchiveId,
                uploadedArchiveName,
                documentTypeId: validationLine.documentTypeId,
                //TODO: documentTypeFormatList
                documentTypeFormat: validationLine.documentTypeFormatList.length === 1 ? validationLine.documentTypeFormatList[0] : DocumentTypeFormat.SINGLE,
                documentTypeCode: validationLine.documentTypeCode,
                relatedId: docValidation.relatedId,
                relatedObjectTypeId: docValidation.relatedObjectTypeId,
                consideredId: docValidation.consideredId,
                consideredObjectTypeId: docValidation.consideredObjectTypeId
              });
            }
          });
        }
      });
      documentalData.sort((docA, docB) => docB.id - docA.id);
      //TODO: Set fetching false
      setDocumentalDataList(value => [...value, ...documentalData]);
      setFetchingDocumentalData(state => false);
    });
  }, []);
  React.useEffect(() => {
    if (!dropMultifileProps) {
      return;
    }
    setFetchingNonTypologyData(state => true);
    archiveRelatedByTypologyWithOnlyDocument({
      relatedId: dossierId,
      typologyCode: dropMultifileProps.othersTypologyCode
    }).then(r => {
      const responseValues = [];
      const existingMap = {};
      const archiveIdDocumentalResultRecord = {};
      if (r.error || !r.data || !r.data.archive_readByRelated_andTypologyWithOnlyDocument) {
        setFetchingNonTypologyData(state => true);
        setErrorNonTypologyData(state => true);
        return;
      }
      r.data.archive_readByRelated_andTypologyWithOnlyDocument.map(archive => {
        responseValues.push({
          id: archive.id.toString(),
          api: {
            id: archive.id,
            name: archive.name
          }
        });
        existingMap[archive.id.toString()] = ArchiveInputState.Uploaded;
        archiveIdDocumentalResultRecord[archive.id.toString()] = archive.documents[0].state;
      });
      setNonTypologyData(_objectSpread(_objectSpread({}, nonTypologyData), {}, {
        dropMultiFileValue: _objectSpread(_objectSpread({}, nonTypologyData.dropMultiFileValue), {}, {
          accepted: responseValues
        }),
        arhiveIdStateRecord: _objectSpread(_objectSpread({}, nonTypologyData.arhiveIdStateRecord), existingMap),
        archiveIdDocumentalResultRecord: _objectSpread(_objectSpread({}, nonTypologyData.archiveIdDocumentalResultRecord), archiveIdDocumentalResultRecord)
      }));
      setFetchingNonTypologyData(state => false);
    });
  }, []);

  //RETURN
  if (fetchingDocumentalData || fetchingNonTypologyData) {
    return /*#__PURE__*/React.createElement("div", {
      className: "d-flex justify-content-center"
    }, /*#__PURE__*/React.createElement(Spinner, {
      className: "text-primary"
    }));
  }
  if (errorDocumentalData || errorNonTypologyData) {
    //TOOD: IF ERROR
    return /*#__PURE__*/React.createElement("div", {
      className: "text-danger"
    }, t('newo.documentalValidation.errorReading'));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "documentalValidation"
  }, documentalDataList.map((doc, i) => {
    var _doc$options;
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: "pb-3"
    }, /*#__PURE__*/React.createElement(DeprecatedDocumentalDropFile, {
      title: doc.title,
      archiveInputState: doc.archiveInputState,
      disabled: doc.archiveInputState == ArchiveInputState.Uploading || !doc.documentTypeId || doc.documentTypeFormat === DocumentTypeFormat.FRONT_BACK || documentalInvididualValidationEnable && !documentalInvididualValidationEnable(doc),
      maxSize: FileMaxSizeBytes ? FileMaxSizeBytes : DocValidationFileMaxSize,
      uploadedArchiveId: doc.uploadedArchiveId,
      uploadedArchiveName: doc.uploadedArchiveName,
      documentalTypologyResult: doc.documentalTypologyResult,
      options: doc.options,
      selectValue: (_doc$options = doc.options) === null || _doc$options === void 0 ? void 0 : _doc$options.find(opt => {
        var _doc$documentTypeId;
        return opt.value === ((_doc$documentTypeId = doc.documentTypeId) === null || _doc$documentTypeId === void 0 ? void 0 : _doc$documentTypeId.toString());
      }),
      selectDisabled: doc.archiveInputState == ArchiveInputState.Uploading || documentalInvididualValidationEnable && !documentalInvididualValidationEnable(doc),
      documentTypeFormat: doc.documentTypeFormat,
      onAccepted: file => onAccepted('file', doc, file),
      onRemoveAccepted: () => onRemoveAccepted('file', doc),
      onRejected: () => onRejected('file', doc),
      onRemoveRejected: () => onRemoveRejected(doc),
      onOptionSelected: option => onOptionSelected(option, doc),
      onAcceptedFront: file => onAccepted('front', doc, file),
      onRemoveAcceptedFront: () => onRemoveAccepted('front', doc),
      onRejectedFront: () => onRejected('front', doc),
      onRemoveRejectedFront: () => onRemoveRejected(doc),
      onAcceptedBack: file => onAccepted('back', doc, file),
      onRemoveAcceptedBack: () => onRemoveAccepted('back', doc),
      onRejectedBack: () => onRejected('back', doc),
      onRemoveRejectedBack: () => onRemoveRejected(doc)
    }));
  }), dropMultifileProps && /*#__PURE__*/React.createElement(NewoDropMultiFileNoTypology, {
    value: nonTypologyData.dropMultiFileValue,
    maxSize: FileMaxSizeBytes ? FileMaxSizeBytes : DocValidationFileMaxSize,
    disabled: dropMultifileProps.disabled && dropMultifileProps.disabled(nonTypologyData.arhiveIdStateRecord),
    onChange: onChangeMultiDrop,
    arhiveIdStateRecord: nonTypologyData.arhiveIdStateRecord,
    archiveIdDocumentalResultRecord: nonTypologyData.archiveIdDocumentalResultRecord,
    title: dropMultifileProps.title
  })));
};
const documentalError = (doc, remove, add) => {
  const newErrors = [...doc.errors];
  let removed = false;
  remove.forEach(e => {
    const hadError = newErrors.indexOf(e);
    if (hadError !== -1) {
      removed = true;
      newErrors.splice(hadError, 1);
    }
  });
  let added = false;
  add.forEach(e => {
    const hadError = newErrors.indexOf(e);
    if (hadError === -1) {
      added = true;
      newErrors.push(e);
    }
  });
  return removed || added ? newErrors : doc.errors;
};